<template>
  <div class="backStack-issue-wrap operationIssue">
    <From
      ref="formRef"
      layoutType="grid"
      :isErrorMessage="false"
      :optionList="formRows"
      :formRules="formRules"
      :defaultModel="defaultModel"
      @updateForm="updateForm"
    >
    </From>
    <UserInfos
      ref="userInfos"
      :infos="userInfo"
      @selectChange="selectChange"
    ></UserInfos>
    <div class="backStack-issue-footer-wrap">
      <div class="read-wrap">
        <a-checkbox @change="readChange"></a-checkbox>
        <span class="text">我已阅读并同意《运营发布规则》</span>
      </div>
      <div class="submit-wrap">
        <a-button class="submit-audit" @click="toAudit">提交审核</a-button>
        <span class="text"
          >温馨提示：运营成果提交后，将由相关人员审核后，方可发布！</span
        >
      </div>
    </div>
  </div>
</template>

<script>
import From from '../../components/formTable/form.vue'
import UserInfos from '../../components/userInfos/index.vue'
import mixinsBackStack from '@/mixins/backStack'
import { formRules, formRows, userInfo } from './configs/formOptions.js'
import { issueInfo, getUserInfo } from '@/api/operationInfo.js'

export default {
  mixins: [mixinsBackStack],
  data() {
    return {
      loading: true,
      userInfo, // 用户信息假数据
      formRows, // 表单item配置
      formRules, // 表单校验规则配置
      defaultModel: {
        publicNum: '',
        applyNum: '',
        legalStatus: '',
        patentName: '',
        patentType: ''
      },
      isRead: false,
      selectValue: ''
    }
  },
  components: {
    From,
    UserInfos
  },
  created() {
    this.initUserInfo()
  },
  methods: {
    selectChange(val) {
      this.selectValue = val
    },
    async initUserInfo() {
      const { data } = await getUserInfo()
      this.dealInfo('userInfo', data)
    },
    // 处理静态信息
    dealInfo(type, result) {
      if (!this[type]) return
      this[type].forEach(item => {
        const { key } = item
        const v = result[key]
        item.value = v || '-'
      })
    },
    readChange(e) {
      const { target } = e
      this.isRead = target.checked
    },
    // 公开号检索
    updateForm(searchV) {
      const {
        inputValue,
        priceRange,
        ...curFormModal
      } = this.$refs.formRef.formModel
      let other =
        priceRange === -1
          ? { priceRange: -1 }
          : { priceRange: inputValue || priceRange }
      this.defaultModel = Object.assign(curFormModal, searchV, other)
    },
    async toAudit() {
      const v = this.$refs.formRef.validatedForm(undefined, function(
        formModal
      ) {
        if (formModal.inputValue === undefined && formModal.priceRange !== -1) {
          this.$apiStatusHandler(99, '预算金额不能为空')
          return false
        }
        return true
      })
      if (!v) return
      if (!this.isRead) {
        return this.$apiStatusHandler(1, '请勾选《需求发布规则》')
      }
      // const formValue = this.$refs.formRef.formModel
      // const userInfo = this.$refs.userInfos.model
      // const params = { ...formValue, ...userInfo }
      // params.orgType = this.selectValue
      const params = this.beforeRequest()
      const { msg, code } = await issueInfo(params)
      this.$apiStatusHandler(code, msg)
      this.$router.push({
        name: 'operationInfos',
        query: { key: 'operationInfos' }
      })
    },
    // 参数处理
    beforeRequest() {
      const { inputValue, ...formValue } = this.$refs.formRef.formModel
      const userInfo = this.$refs.userInfos.model
      const params = { ...formValue, ...userInfo }
      params.orgType = this.selectValue
      if (inputValue) {
        params.priceRange = inputValue
      }
      return params
    },
    initForm() {
      this.$refs.formRef.initOptions()
      this.defaultModel = {
        publicNum: '',
        applyNum: '',
        legalStatus: '',
        patentName: '',
        patentType: ''
      }
      this.isRead = false
    }
  }
}
</script>
